import { useEffect } from 'react';

export const useResetFiltersOnUnmount = (resetFilters: () => void) => {
  useEffect(() => {
    return () => {
      resetFilters();
    };
  }, []);
};
